import {
  FilterMode,
  PermissionCreateMutationVariables,
  Permission_OrderBy,
  Permission,
  SortOrder,
  Permission_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const permissionService = {
  createOne: buildCreateOne(
    (permissionCreateVariables: PermissionCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.permissionCreate(permissionCreateVariables);
        return result.permissionCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.permissionOne({ id });
    return result.permissionOne as Permission;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: Permission_OrderBy[] | null = null,
    filter: Permission_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Permission_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { id: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            [fieldByLang("name", language)]: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.permissionListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.permissionListWithOffset
    ) as Permission[];
    return { list, orderBy };
  },
};
